import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})

export class CustomToastrService {
  constructor(private translateService: TranslateService, private toastr: ToastrService) { }

  showSuccessToast(headerKey: string, MsgKey: string) {
    let header = "";
    let msg = "";
    this.translateService.get(headerKey).subscribe((translation: any) => {
      header = translation;
    });

    this.translateService.get(MsgKey).subscribe((translation: any) => {
      msg = translation;
    });

    setTimeout(() => { this.toastr.success(msg, header); }, 500);
  }

  showErrorToast(headerKey: string, messageKey: string) {
    let header = "";
    this.translateService.get(headerKey).subscribe((translation: any) => {
      header = translation;
    });

    let message = "";
    this.translateService.get(messageKey).subscribe((translation: any) => {
      message = translation;
    });

    setTimeout(() => { this.toastr.error(message, header); }, 500);
  }

  showWarningToast(headerKey: string | null, messageKey: string) {
    let header = "";
    if(headerKey){
      this.translateService.get(headerKey).subscribe((translation: any) => {
        header = translation;
      });
    }

    let message = "";
    this.translateService.get(messageKey).subscribe((translation: any) => {
      message = translation;
    });

    setTimeout(() => { this.toastr.warning(message, header); }, 500);
  }
}
